module.exports = __webpack_public_path__ + "img/327449279.ef93f8d8.jpg";